import { render, staticRenderFns } from "./UserActivityDescription.vue?vue&type=template&id=04a8b83e&"
import script from "./UserActivityDescription.vue?vue&type=script&lang=js&"
export * from "./UserActivityDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports